import ProductVersion from '@/models/ProductVersion';

export default class ProductVersionRepository {
    public static getAll() {
        return ProductVersion.all();
    }
}
